(function() {
  if (App.angularApp == null) {
    return;
  }


  /*
   * mf-uc-words
   *
   * takes string, uppercases words like php's ucwords
   *
   */

  App.angularApp.filter('mfUcWords', function() {
    return (function(_this) {
      return function(input) {
        var i, k, len, v, words;
        if (input) {
          words = input.split(/[\s_]+/);
          for (k = i = 0, len = words.length; i < len; k = ++i) {
            v = words[k];
            words[k] = v.substring(0, 1).toUpperCase() + v.substring(1);
          }
          return words.join(' ');
        }
      };
    })(this);
  });

}).call(this);
